import {Component, Input, OnInit, OnChanges, Output, EventEmitter, ViewChild} from '@angular/core';
import {FormGroupBaseComponent} from "../../formgroupbase.component";
import {InputHelper} from "../../../../Helpers/InputHelper";

@Component({
  selector: 'jbm-integer-input-group',
  templateUrl: './JBMIntegerInputGroup.component.html',
  styleUrls: ['./JBMIntegerInputGroup.component.scss']
})

export class JBMIntegerInputGroupComponent extends FormGroupBaseComponent implements OnInit, OnChanges {
  @Input() type: string='text';
  @Input() maxlength: number=0;
  @Input() negativeAllowed: boolean=true;
  @Input() emptyIfZero: boolean=true;
  @Input() prepend: string;
  @Input() append: string;
  @Output() onBlur = new EventEmitter();

  override ngOnInit() {
    if(this.type==undefined) this.type='text';
    if(this.maxlength==undefined) this.maxlength=0;
    if(this.prepend==undefined) this.prepend='';
    if(this.append==undefined) this.append='';

    super.ngOnInit();
  }
  blur(event: any) {
    if(typeof this.ngControl.control.value==='number')
      this.ngControl.control.setValue(this.ngControl.control.value.toString());

    let value=this.ngControl.control.value.trim();
    if(!value) {
      this.onBlur.emit(event);
      return;
    }

    let helper=new InputHelper();
    value=helper.sanitizeIntegerValue(value, this.emptyIfZero);

    this.ngControl.control.setValue(value);
    this.onBlur.emit(event);
  }
}
